/** @override King Living: FullIconSetFragment with appearance-driven CF-053 / CF-054 layouts. */

import gql from 'graphql-tag';

import {IconFragment} from '@amblique/contentful/app/contentful/fragments/icon/icon.fragment';
import {BaseIconSetFragment} from '@amblique/king-living/app/contentful/fragments/icon-set/base-icon-set.fragment';

export const FullIconSetFragment = gql`
  ${BaseIconSetFragment}
  ${IconFragment}

  fragment FullIconSetFragment on IconSet {
    ...BaseIconSetFragment

    iconsCollection {
      items {
        __typename
        ... on Icon {
          ...IconFragment
        }
      }
    }
  }
`;
